import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const StarIcon = ({ fill = '#F5A623', width = 16, height = 16, title = 'Primary contact', }) => {
    return (_jsxs("svg", { role: "img", "aria-label": title, width: width, height: height, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [_jsx("title", { children: title }), _jsx("path", { d: "M12 2.5l2.94 5.96 6.58.96-4.76 4.64 1.12 6.55L12 17.52l-5.88 3.09 1.12-6.55L2.48 9.42l6.58-.96L12 2.5z", fill: fill })] }));
};
export default StarIcon;
